import { createJsonlImportClient } from "./jsonlImportApi";

export const clientImportApi = createJsonlImportClient("/api/clients");
export const skuImportApi = createJsonlImportClient("/api/articles");
export const articleSeasonImportApi = createJsonlImportClient(
  "/api/articles/seasons"
);
export const paymentMethodImportApi = createJsonlImportClient(
  "/api/acceptedPaymentMethod"
);
export const promotionImportApi = createJsonlImportClient("/api/promotions");
export const pointsMovementImportApi = createJsonlImportClient(
  "/api/clients/points-movements"
);
export const branchOfficeImportApi = createJsonlImportClient(
  "/api/branchOffices"
);
export const purchaseOrderImportApi = createJsonlImportClient(
  "/api/purchaseOrders"
);
export const repositionOrderImportApi = createJsonlImportClient(
  "/api/repositionOrders"
);
